import { Component, OnInit, ViewChild } from '@angular/core';
import { Listing } from '../../../../shared/models/listing.model';
import { Languages, Service } from '../../../../shared/models/enums.model';
import { GlobalServices } from '../../../../shared/services/global.service';
import { GridViewComponent } from '../../../../shared/components/grid-view/grid-view.component';
import { ReportsService } from '../../../../shared/services/reports.service';
import { Router } from '@angular/router';
import { AppConfig } from '../../../../shared/services/app.config';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../../../shared/models/user.model';


//import { DatePipe } from '@angular/common';
import { DatePipe } from '@angular/common';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import {enGbLocale} from 'ngx-bootstrap/locale';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { MyRequestsLookups } from 'src/app/shared/components/my-requests/my-requests.component';
import { MyRequestsService } from 'src/app/shared/services/my-Requests.service';

@Component({
  selector: 'app-shipyard-report',
  templateUrl: './shipyard-report.component.html',
  styleUrls: ['./shipyard-report.component.css']
})

export class ShipyardReportComponent implements OnInit {

  //#region Properties & Variables
  private collection: Listing;
  private itemsMenu: MenuItem[] = [];
  lang: string;
  pageSize = 15;
  creationDateFrom: string = "";
  creationDateTo: string = "";
  dateFromFormatted: string = "";
  dateToFormatted: string = "";
  serviceId: string = "";
  serviceStatus: string = "";
  requestNumber: string = "";
  myShipyardReportLookups: ShipyardReportLookups;
  public currentUser: User = new User();
  InvalidDateMessage: string;
  responseObj: ResponseObject;
  isErrorMessage: Boolean = false;
  myRequestsLookups: MyRequestsLookups;
  dateFromCompare: any;
  dateToCompare: any;


  @ViewChild('MyShipyardReport',{static: false}) gridView: GridViewComponent;
  hideExportButton: Boolean;
  //#endregion

  get ValidateDateComparsion() {
    if (this.creationDateFrom && this.creationDateTo) {
      let Gate = false;
      let currStartDate = new Date(this.creationDateFrom);
      let currEndDate = new Date(this.creationDateTo);
      if (currStartDate.getFullYear() > currEndDate.getFullYear()) {
        Gate = true;
      }
      else if (currStartDate.getFullYear() == currEndDate.getFullYear()) {
        if (currStartDate.getMonth() > currEndDate.getMonth()) {
          Gate = true;
        }
        else if (currStartDate.getMonth() == currEndDate.getMonth()) {
          if (currStartDate.getDate() > currEndDate.getDate()) {
            Gate = true;
          }
        }
      }
      return Gate;
    }
  }

  constructor(private myReportsService: ReportsService, private global: GlobalServices, private translate: TranslateService, private router: Router, private localeService: BsLocaleService, public datepipe: DatePipe, private myRequestsService: MyRequestsService) {
    this.lang = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
  }

  async ngOnInit() {
    this.InvalidDateMessage = await this.translate.get('SHARED.InvalidDate').toPromise();
    this.currentUser = this.global.user;
    enGbLocale.invalidDate = this.InvalidDateMessage;
    defineLocale('custom locale', enGbLocale);
    this.localeService.use('custom locale');
    if (this.currentUser.IsAdmin) {
      this.lang = this.global.getLanguage() == Languages.Arabic ? "Ar" : "En";
      this.loadLookups();
      // this.loadShipyardReport();

    }
    else {
      this.router.navigateByUrl('/workspace');
    }
  }

  loadShipyardReport() {
    this.creationDateFrom = this.creationDateFrom == null ? "" : this.creationDateFrom;
    this.creationDateTo = this.creationDateTo == null ? "" : this.creationDateTo;


    if (this.creationDateFrom.toString() != this.InvalidDateMessage && this.creationDateTo.toString() != this.InvalidDateMessage) {
      this.dateFromFormatted = this.creationDateFrom == "" ? "" : this.creationDateFrom.toString().indexOf("-") > -1 ? this.datepipe.transform(new Date(this.creationDateFrom.split('-')[1] + '/' +
      this.creationDateFrom.split('-')[0] + '/' + this.creationDateFrom.split('-')[2]) , 'MM/dd/yyyy') :
      this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
this.dateToFormatted = this.creationDateTo == "" ? "" : this.creationDateTo.toString().indexOf("-") > -1 ? this.datepipe.transform(new Date(this.creationDateTo.split('-')[1] + '/' +
      this.creationDateTo.split('-')[0] + '/' + this.creationDateTo.split('-')[2]) , 'MM/dd/yyyy') :
      this.datepipe.transform(this.creationDateTo, 'MM/dd/yyyy');
      // this.dateFromFormatted = this.creationDateFrom == "" ? "" : this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
      // this.dateToFormatted = this.creationDateTo == "" ? "" : this.datepipe.transform(this.creationDateTo, 'MM/dd/yyyy');
      if (this.dateToFormatted != "" && this.ValidateDateComparsion) {
        return;
      }
      this.global.isLoaderEnabled = true;

      this.getShipyardReport();
    }
  }


  loadSearchCriteria() {
    if (this.global.shipyardSearchCriteria.length > 0) {
      this.creationDateFrom = this.global.shipyardSearchCriteria[0].creationDateFrom == "" ? "" : this.datepipe.transform(new Date(this.global.shipyardSearchCriteria[0].creationDateFrom.split('-')[1] + '/' +
        this.global.shipyardSearchCriteria[0].creationDateFrom.split('-')[0] + '/' +
        this.global.shipyardSearchCriteria[0].creationDateFrom.split('-')[2]), 'dd-MM-yyyy');
      this.creationDateTo = this.global.shipyardSearchCriteria[0].creationDateTo == "" ? "" : this.datepipe.transform(new Date(this.global.shipyardSearchCriteria[0].creationDateTo.split('-')[1] + '/' +
        this.global.shipyardSearchCriteria[0].creationDateTo.split('-')[0] + '/' +
        this.global.shipyardSearchCriteria[0].creationDateTo.split('-')[2]), 'dd-MM-yyyy');
      this.serviceId = this.global.shipyardSearchCriteria[0].serviceId;
      this.serviceStatus = this.global.shipyardSearchCriteria[0].serviceStatus;
      this.requestNumber = this.global.shipyardSearchCriteria[0].requestNumber;

      this.global.shipyardSearchCriteria = [];
      this.changeService(this.serviceId, true);
    }
  }

  getShipyardReport() {
    this.dateFromFormatted = this.creationDateFrom == "" ? "" : this.creationDateFrom.toString().indexOf("-") > -1 ? this.datepipe.transform(new Date(this.creationDateFrom.split('-')[1] + '/' +
      this.creationDateFrom.split('-')[0] + '/' + this.creationDateFrom.split('-')[2]), 'MM/dd/yyyy') :
      this.datepipe.transform(this.creationDateFrom, 'MM/dd/yyyy');
    this.dateToFormatted = this.creationDateTo == "" ? "" : this.creationDateTo.toString().indexOf("-") > -1 ? this.datepipe.transform(new Date(this.creationDateTo.split('-')[1] + '/' +
      this.creationDateTo.split('-')[0] + '/' + this.creationDateTo.split('-')[2]), 'MM/dd/yyyy') :
      this.datepipe.transform(this.creationDateTo, 'MM/dd/yyyy');

    this.global.shipyardSearchCriteria = [];
    this.global.shipyardSearchCriteria.push({
      creationDateFrom: this.creationDateFrom == "" ? "" : this.creationDateFrom.toString().indexOf("-") > -1 ? this.creationDateFrom :
        this.datepipe.transform(this.creationDateFrom, 'dd-MM-yyyy'),
      creationDateTo: this.creationDateTo == "" ? "" : this.creationDateTo.toString().indexOf("-") > -1 ? this.creationDateTo :
        this.datepipe.transform(this.creationDateTo, 'dd-MM-yyyy'),
      serviceId: this.serviceId,
      serviceStatus: this.serviceStatus,
      requestNumber :this.requestNumber
    });

    this.myReportsService.getShipyardReport(this.global.user.UserName, 0, this.pageSize, this.dateFromFormatted, this.dateToFormatted, this.serviceId, this.serviceStatus,this.requestNumber).subscribe(
      s => {
        this.responseObj = s;
        if (!this.responseObj.Success) {
          this.isErrorMessage = true;
        }

        this.collection = s.Data;
        this.hideExportButton = s.Data == null ? true : false;
      },
      () => console.log("Something went wrong!!"),
      () => this.loadCollectionCompleted(this.dateFromFormatted, this.dateToFormatted));
  }

  loadCollectionCompleted(formattedDateFrom: string, formattedDateTo: string) {
    this.loadItemsMenu();
    this.gridView.loadGrid(this.collection, this.collection == null ? 0 : this.collection.TotalNumber, this.pageSize,
      "Report/GetShipyardReport?email=" + this.global.user.UserName + "&pageIndex={PAGEINDEX}&pageSize=" + this.pageSize +
      "&language=" + (this.global.getLanguage() == Languages.Arabic ? "Ar" : "En") +
      "&from=" + formattedDateFrom + "&to=" + formattedDateTo + "&serviceId=" + this.serviceId +
      "&statusId=" + this.serviceStatus+"&requestNumber="+this.requestNumber,
      "SHARED.REPORTS.SHIPYARD_OBJECT", this.itemsMenu, "", "", "");
    //Disable Loader
    this.global.isLoaderEnabled = false;
  }

  resetMyShipyardReport() {
    this.creationDateFrom = "";
    this.creationDateTo = "";
    this.dateFromFormatted = "";
    this.dateToFormatted = "";
    this.serviceId = "";
    this.serviceStatus = "";
    this.requestNumber = "";
    this.hideExportButton = false;
    this.loadShipyardReport();
  }

  // loadItemsMenu() {
  //   this.itemsMenu[0] = new MenuItem();
  //   this.itemsMenu[0].Title = "Details";
  //   this.itemsMenu[0].TitleAr = "التفاصيل";
  //   this.itemsMenu[1] = new MenuItem();
  //   this.itemsMenu[1].Title = "Request History";
  //   this.itemsMenu[1].TitleAr = "تاريخ الطلب";
  // }

  loadItemsMenu() {
    this.itemsMenu[0] = new MenuItem();
    this.itemsMenu[0].Title = "Details";
    this.itemsMenu[0].TitleAr = "التفاصيل";
    this.itemsMenu[1] = new MenuItem();
    this.itemsMenu[1].Title = "Request History";
    this.itemsMenu[1].TitleAr = "تاريخ الطلب";
    if (this.currentUser.IsAdmin) {
      this.itemsMenu[2] = new MenuItem();
      this.itemsMenu[2].Title = "Workflow Status";
      this.itemsMenu[2].TitleAr = "حالة مسار العمل";
    }
  }

  changeService(serviceId, isLoadingSearchCriteria) {
    this.myRequestsLookups.Statuses = [];
    if (!isLoadingSearchCriteria)
      this.serviceStatus = "";
    this.myRequestsService.getMyRequestsStatusesLookups(serviceId).subscribe(
      data => this.myRequestsLookups.Statuses = data.Data.Statuses,
      () => console.log("Something went wrong!!"),
      // () => this.loadLookupsCompleted()
    );

  }
  loadLookupsCompleted() {
    this.loadSearchCriteria();
    this.loadShipyardReport();
  }
  loadLookups() {

    this.myReportsService.getShipyardReportFilterLookups().subscribe(
      data => this.myRequestsLookups = data.Data,
      () => console.log("Something went wrong!!"),
      () => this.loadLookupsCompleted(),
      // () => console.log("Completed")
    );
  }

  ExportExcel() {
    var objectName;
    if (this.serviceId == Service.Repair.toString()) {
      objectName = 'SHARED.REPORTS.SHIPYARD_OBJECT_EXPORT';
    } else if (this.serviceId == Service.DynamicBalancing.toString()) {
      objectName = 'SHARED.REPORTS.SHIPYARD_OBJECT_DYNAMIC_EXPORT';
    } else if (this.serviceId == Service.HardnessTest.toString()) {
      objectName = 'SHARED.REPORTS.SHIPYARD_OBJECT_HARDENESS_EXPORT';
    } else if (this.serviceId == Service.NonDestructiveTestingWork.toString()) {
      objectName = 'SHARED.REPORTS.SHIPYARD_OBJECT_NON_DESTRUCTIVE_EXPORT';

    } else if (this.serviceId == Service.FiberGlass.toString()) {
      objectName = 'SHARED.REPORTS.SHIPYARD_OBJECT_FIBER_GLASS_EXPORT';

    }

    else if (this.serviceId == Service.FloatingCranes.toString()) {
      objectName = 'SHARED.REPORTS.SHIPYARD_OBJECT_FLOATINGCRANES';
    }
    else if (this.serviceId == Service.Salvage.toString()) {
      objectName = 'SHARED.REPORTS.SHIPYARD_OBJECT_Salvage_EXPORT';
    }

    this.translate.get(objectName).subscribe((response: string) => {
      this.myReportsService.ExportShipyardReportExcel(this.global.user.UserName, JSON.stringify(response),
        this.lang, this.dateFromFormatted, this.dateToFormatted, this.serviceId, this.serviceStatus ,this.requestNumber)
    });
  }
}

export class MenuItem {
  Title: string;
  TitleAr: string;
};

export class ShipyardReportLookups {
  public Services = [];
  public Statuses = [];
};
